import React, { FC } from 'react';
import { ISelectOption } from '../../../../utils/types';
import MultiSelectFilter from '../multi-select-filter/MultiSelectFilter';
import IStatusFilter from './IStatusFilter';

const StatusFilter: FC<IStatusFilter> = ({ options, placeholder, setFilters, disabled }) => {
	const filterKey = 'statusFilter';
	const propertyName = 'status';

	const onMultiSelectValueChange = (value: ISelectOption[]) => {
		if (!value.length) {
			setFilters((prev: any) => ({
				...prev,
				[filterKey]: (dataRecord: any) => true,
			}));
			return;
		}

		setFilters((prev: any) => ({
			...prev,
			[filterKey]: (dataRecord: any) =>
				value.some((v) => {
					return v.value === dataRecord[propertyName];
				}),
		}));
	};

	return (
		<MultiSelectFilter
			placeholder={placeholder || 'Status'}
			options={options || []}
			onChange={onMultiSelectValueChange}
			isTagStyledList
			disabled={disabled}
		/>
	);
};

export default StatusFilter;
